import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
// -- Front website --
import Index from '@/components/index/Index'
import About from '@/components/index/About'
import IndexActivity from '@/components/index/Activity'
import IndexActivityInfo from '@/components/index/ActivityInfo'
import ServiceDetail from '@/components/index/ServiceDetail'
import IndexContact from '@/components/index/Contact'
import IndexNews from '@/components/index/News'
import IndexNewsInfo from '@/components/index/NewsInfo'
import IndexMedia from '@/components/index/Media'
import IndexMediaInfo from '@/components/index/MediaInfo'
import IndexCooperate from '@/components/index/Cooperate'
import IndexCooperateInfo from '@/components/index/CooperateInfo'
import IndexWorld from '@/components/index/World'
import IndexWorldInfo from '@/components/index/WorldInfo'
import IndexView from '@/components/index/View'
import IndexViewInfo from '@/components/index/ViewInfo'
import IndexResearch from '@/components/index/Research'
import IndexResearchInfo from '@/components/index/ResearchInfo'
import Privacy from '@/components/index/Privacy'

// -- Admin website--
import Home from '@/components/Home'
import Login from '@/components/Login'
import Banner from '@/components/Banner'
import BannerEN from '@/components/BannerEN'
import User from '@/components/User'
import UserInfo from '@/components/UserInfo'
import Faculty from '@/components/Faculty'
import FacultyInfo from '@/components/FacultyInfo'
import FacultyEN from '@/components/FacultyEN'
import FacultyInfoEN from '@/components/FacultyInfoEN'
import Activity from '@/components/Activity'
import ActivityInfo from '@/components/ActivityInfo'
import ActivityEN from '@/components/ActivityEN'
import ActivityInfoEN from '@/components/ActivityInfoEN'
import Category from '@/components/Category'
import CategoryInfo from '@/components/CategoryInfo'
import CategoryEN from '@/components/CategoryEN'
import CategoryInfoEN from '@/components/CategoryInfoEN'
import News from '@/components/News'
import NewsInfo from '@/components/NewsInfo'
import NewsEN from '@/components/NewsEN'
import NewsInfoEN from '@/components/NewsInfoEN'
import Contact from '@/components/Contact'
import ContactInfo from '@/components/ContactInfo'
import ContactEN from '@/components/ContactEN'
import ContactInfoEN from '@/components/ContactInfoEN'
import NotFound from '@/components/NotFound'
import Error from '@/components/Error'
import Image from '@/components/Image'
import Import from '@/components/Import'
import Vueaxios from 'vue-axios'
import axios from 'axios'
Vue.use(Router)
Vue.use(VueResource)
Vue.prototype.axios = axios
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },{
      path: '/about',
      name: 'About',
      component: About
    },{
      path: '/ourmember',
      name: 'ServiceDetail',
      component: ServiceDetail
    },{
      path: '/contact',
      name: 'IndexContact',
      component: IndexContact
    },{
      path: '/activity',
      name: 'IndexActivity',
      component: IndexActivity
    },{
      path: '/activity/:id',
      name: 'IndexActivityInfo',
      component: IndexActivityInfo
    },{
      path: '/news',
      name: 'IndexNews',
      component: IndexNews
    },{
      path: '/news/:id',
      name: 'IndexNewsInfo',
      component: IndexNewsInfo
    },{
      path: '/media',
      name: 'IndexMedia',
      component: IndexMedia
    },{
      path: '/media/:id',
      name: 'IndexMediaInfo',
      component: IndexMediaInfo
    },{
      path: '/cooperate',
      name: 'IndexCooperate',
      component: IndexCooperate
    },{
      path: '/cooperate/:id',
      name: 'IndexCooperateInfo',
      component: IndexCooperateInfo
    },{
      path: '/world',
      name: 'IndexWorld',
      component: IndexWorld
    },{
      path: '/world/:id',
      name: 'IndexWorldInfo',
      component: IndexWorldInfo
    },{
      path: '/view',
      name: 'IndexView',
      component: IndexView
    },{
      path: '/view/:id',
      name: 'IndexViewInfo',
      component: IndexViewInfo
    },{
      path: '/research',
      name: 'IndexResearch',
      component: IndexResearch
    },{
      path: '/research/:id',
      name: 'IIndexResearchInfo',
      component: IndexResearchInfo
    },{
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/admin/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin',
      name: 'Home',
      component: Home
    },{
      path: '/admin/banner',
      name: 'Banner',
      component: Banner
    },{
      path: '/admin/banner_en',
      name: 'Banner_en',
      component: BannerEN
    },{
      path: '/admin/user',
      name: 'User',
      component: User
    },{
      path: '/admin/user/add',
      name: 'UserAdd',
      component: UserInfo
    },{
      path: '/admin/user/:id',
      name: 'UserEdit',
      component: UserInfo
    },{
      path: '/admin/faculty',
      name: 'Faculty',
      component: Faculty
    },{
      path: '/admin/faculty/add',
      name: 'FacultyAdd',
      component: FacultyInfo
    },{
      path: '/admin/faculty/:id',
      name: 'FacultyEdit',
      component: FacultyInfo
    },{
      path: '/admin/faculty_en',
      name: 'Faculty_en',
      component: FacultyEN
    },{
      path: '/admin/faculty_en/add',
      name: 'Faculty_enAdd',
      component: FacultyInfoEN
    },{
      path: '/admin/faculty_en/:id',
      name: 'Faculty_enEdit',
      component: FacultyInfoEN
    },{
      path: '/admin/activity/',
      name: 'Activity',
      component: Activity
    },{
      path: '/admin/activity/add',
      name: 'ActivityAdd',
      component: ActivityInfo
    },{
      path: '/admin/activity/:id',
      name: 'ActivityEdit',
      component: ActivityInfo
    },{
      path: '/admin/activity_en/',
      name: 'Activity_en',
      component: ActivityEN
    },{
      path: '/admin/activity_en/add',
      name: 'Activity_enAdd',
      component: ActivityInfoEN
    },{
      path: '/admin/activity_en/:id',
      name: 'Activity_enEdit',
      component: ActivityInfoEN
    },{
      path: '/admin/category',
      name: 'Category',
      component: Category
    },{
      path: '/admin/category/add',
      name: 'CategoryAdd',
      component: CategoryInfo
    },{
      path: '/admin/category/:section_id/:id',
      name: 'CategoryEdit',
      component: CategoryInfo
    },{
      path: '/admin/category_en',
      name: 'Category_en',
      component: CategoryEN
    },{
      path: '/admin/category_en/add',
      name: 'Category_enAdd',
      component: CategoryInfoEN
    },{
      path: '/admin/category_en/:section_id/:id',
      name: 'Category_enEdit',
      component: CategoryInfoEN
    },{
      path: '/admin/news',
      name: 'News',
      component: News
    },{
      path: '/admin/news/add',
      name: 'NewsAdd',
      component: NewsInfo
    },{
      path: '/admin/news/:id',
      name: 'NewsEdit',
      component: NewsInfo
    },{
      path: '/admin/news_en',
      name: 'News_en',
      component: NewsEN
    },{
      path: '/admin/news_en/add',
      name: 'News_enAdd',
      component: NewsInfoEN
    },{
      path: '/admin/news_en/:id',
      name: 'News_enEdit',
      component: NewsInfoEN
    },{
      path: '/admin/contact',
      name: 'Contact',
      component: Contact
    },{
      path: '/admin/contact/add',
      name: 'ContactAdd',
      component: ContactInfo
    },{
      path: '/admin/contact/:id',
      name: 'ContactEdit',
      component: ContactInfo
    },{
      path: '/admin/contact_en',
      name: 'Contact_en',
      component: ContactEN
    },{
      path: '/admin/contact_en/add',
      name: 'Contact_enAdd',
      component: ContactInfoEN
    },{
      path: '/admin/contact_en/:id',
      name: 'Contact_enEdit',
      component: ContactInfoEN
    },{
      path: '/admin/import',
      name: 'Import',
      component: Import
    },{
      path: '/admin/image',
      name: 'Image',
      component: Image
    },{
      path: '/error',
      name: 'Error',
      component: Error
    },{
      path: '*',
      component: NotFound
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js